export default __webpack_public_path__ + "072d51bcc9c09311d4c2a6708b05bddc.png";